<template>
    <div class="order-info">
        <div class="cell-group border__top">
            <div class="cell">
                <div class="cell-title">支付项目</div>
                <div class="cell-value">{{info.name}}</div>
            </div>
            <div class="cell">
                <div class="cell-title">确认笔数</div>
                <div class="cell-value">{{info.total}}</div>
            </div>
        </div>
        <div class="cell-group">
            <div class="cell">
                <div class="cell-title">服务合计(元)</div>
                <div class="cell-value">{{info.money}}</div>
            </div>
            <div class="cell">
                <div class="cell-title">服务费合计(元)</div>
                <div class="cell-value">{{info.service_fee}}</div>
            </div>
        </div>
        <div class="cell-group">
            <div class="cell">
                <div class="cell-title">待支付总额(元)</div>
                <div class="cell-value text-danger" style="font-size: 14px; line-height: 12px;">{{info.to_pay}}</div>
            </div>
            <div class="cell">
                <div class="cell-title">&nbsp;</div>
                <div class="cell-value">&nbsp;</div>
            </div>
        </div>

        <div class="form-content">
            <el-form label-width="80px" style="width: 360px;margin: 0 auto;" @submit.native.prevent class="pay-form">
                <el-form-item label="支付方式:">
                    <div>余额支付</div>
                </el-form-item>
                <el-form-item label="账户金额:">
                    <div>{{use_money}}元</div>
                </el-form-item>
                <el-form-item label="支付密码:">
                    <el-input v-model="pay_password" placeholder="请输入支付密码" type="password"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="medium" @click="onSubmit">确认支付</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import qs from 'qs'
import router from '@/router'

export default {
    name: 'Step3',
    data () {
        return {
            userInfo: {},
            list: [],
            pay_password: '',
            info: {},
            use_money: 0
        }
    },
    mounted () {
        if (localStorage.getItem('BATCHES')) {
            this.info = JSON.parse(localStorage.getItem('BATCHES'))
            this.list = this.info.list
            localStorage.removeItem('BATCHES')
        } else {
            this.$message.error('系统错误，请稍后再试。')
            router.replace('/index/project/detail?id=' + this.$route.query.id + '&panel=1')
        }
        this.getMoney()
    },
    methods: {
        getMoney () {
            this.$http.get('/api/user/userinfo')
                .then(res => {
                    if (res.code === 0) {
                        this.userInfo = res.data
                        this.use_money = res.data.use_money
                    } else {
                        this.$message.error(res.message)
                    }
                })
                .catch(err => {
                    console.log(err)
                })
        },
        onSubmit () {
            if (this.pay_password === '') {
                this.$message.error('请输入支付密码')
            } else {
                this.$http.post('/api/user/project/batchpay', qs.stringify({
                    id: this.$route.query.id,
                    pay_password: this.pay_password,
                    money: this.info.to_pay,
                    list: JSON.stringify(this.list)
                }))
                    .then((res) => {
                        if (res.code === 0) {
                            this.$notify.success({
                                title: '通知',
                                message: '支付成功。'
                            })
                            if (this.userInfo.role_id === 3) {
                                router.replace(`/index/pay/prepaid`)
                            } else {
                                router.replace(`/index/project/detail?id=${this.$route.query.id}&panel=1`)
                            }
                        } else {
                            this.$message.error(res.message)
                        }
                    })
                    .catch(err => {
                        console.log(err)
                        // this.$Message.error('网络错误，请稍候再试。');
                    })
            }
        }
    }
}
</script>

<style scoped lang="scss">
    @import "../../assets/style/sub.scss";

    .pay-form {
        .el-form-item {
            margin-bottom: 10px;
        }

        padding-top: 80px;
        padding-bottom: 40px;
    }

    .order-info {
        padding: 0 40px;
        background-color: #fff;
    }

    .cell-group {
        display: flex;
        border-right: 1px solid #ebeef5;

        .cell {
            flex: 1;
            border-bottom: 1px solid #ebeef5;
            border-left: 1px solid #ebeef5;
            display: flex;
            align-items: center;
            font-size: 12px;

            .cell-title {
                background-color: #f5f5fa;
                flex: 1;
                padding: 17px 20px;
            }

            .cell-value {
                flex: 1;
                padding: 17px 20px;
                max-width: 50%;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }

        &:nth-child(1) {
            border-top: 1px solid #ebeef5;
        }
    }
</style>
